import React from 'react'

import LoadingComponent from '../../gd-ui/loading/loading'
import Project from "../../model2/project/project"

// @ts-ignore
import Api from '../../../core/gd/api/api'
// @ts-ignore
import FormStatus from './components/form-status'

type Props = {
    projectId: ID
}

export default class ModalUpdateStatus extends React.Component<Props, any> {

    constructor(props:Props) {
        super(props)

        this.state = {
            projectFull: null
        }
    }

    async componentDidMount() {
        const response = await Api.Project.getProject(this.props.projectId).promise()

        this.setState({projectFull: new Project(response)})
    }

    render() {
        if (this.state.projectFull) {
            return <FormStatus projectFull={this.state.projectFull}/>
        }

        return (
            <div className="flex-row-center-center" style={{height: 313}}>
                <LoadingComponent/>
            </div>
        )
    }
}